import {Down, Language} from '@baidu/xicon-react';
import {Dropdown} from 'antd';
import style from './index.less';

export default function SwitchLang({items}) {
    return (
        <div className={style.wrap} id="switch-lang-container">
            <Language className={style.icon} theme="line" color="#000" size={16} strokeLinejoin="round" />
            <Dropdown
                getPopupContainer={() => document.getElementById('switch-lang-container')!}
                menu={{
                    items: [{label: '中国站:', key: 'chinasite', disabled: true}, ...items],
                }}
            >
                <span style={{fontSize: 12, display: 'flex', alignItems: 'center'}}>
                    中国站
                    <Down className={style.down} theme="line" color="#000" size={16} />
                </span>
            </Dropdown>
        </div>
    );
}
